/*
  cart-state.js — stato "Nel carrello" sui pulsanti di aggiunta.

  PROBLEMA RISOLTO
  Dopo un'aggiunta riuscita il pulsante tornava identico a prima ("Aggiungi al
  carrello", premibile): nulla diceva che il capo era gia' dentro, quindi
  l'utente ripremeva. Sulla pagina prodotto Shopify rispondeva 422 e compariva
  il messaggio rosso; sulle card di collezione product-form.js commutava invece
  il pulsante su "Esaurito" — scritta falsa e dannosa, perche' il capo non e'
  finito: e' nel carrello di chi sta guardando.

  COSA FA
  Legge il carrello reale (GET /cart.js) a ogni caricamento di pagina e porta i
  pulsanti dei capi gia' nel carrello in uno stato "Nel carrello" che non
  ritenta l'aggiunta: al tap riapre la notifica carrello — la stessa che
  compare dopo un'aggiunta — senza far cambiare pagina. L'aggiunta e' impedita
  intercettando click e submit in fase di cattura, senza toccare gli attributi
  del pulsante da cui dipende product-form.js (vedi nota in setInCart).

  PERCHE' LATO CLIENT E NON IN LIQUID
  Il contenuto del carrello e' personale, le pagine prodotto e collezione sono
  cacheabili: scrivere lo stato nell'HTML rischia di servire il carrello di un
  visitatore a un altro. Leggerlo a ogni caricamento rende corretto anche il
  reload, il ritorno da /cart dopo una rimozione e il ritorno indietro dalla
  cache di navigazione (bfcache).

  COSA NON TOCCA
  product-form.js resta il Dawn di serie: ci agganciamo agli eventi che
  pubblica gia' (cart-update / cart-error). Nessuna modifica a cart.js o ai CSS
  del carrello (fix "dead click / serranda" del 2026-08-21).

  INTERRUTTORE
  Tutto il comportamento e' subordinato a window.cartStateSettings.uniquePieces
  (definito in snippets/cart-notification.liquid): dichiara che il catalogo e'
  fatto di pezzi unici, quindi che una seconda aggiunta non e' mai legittima.
  A false, questo file non fa assolutamente nulla.
*/
(function () {
  'use strict';

  var settings = window.cartStateSettings || {};
  if (settings.uniquePieces !== true) return;

  var strings = window.cartStateStrings || {};

  var IN_CART_ATTR = 'data-in-cart';
  var SECTIONS = ['cart-notification-product', 'cart-notification-button', 'cart-icon-bubble'];

  var events =
    typeof PUB_SUB_EVENTS !== 'undefined'
      ? PUB_SUB_EVENTS
      : { cartUpdate: 'cart-update', cartError: 'cart-error', variantChange: 'variant-change' };

  // variant id (stringa) -> key della riga di carrello
  var keysByVariant = {};
  var cartLoaded = false;
  var domObserver = null;

  // Memoria di sessione: serve solo ad applicare lo stato *subito*, senza
  // aspettare la rete. Senza, a ogni caricamento il pulsante mostrava
  // "Aggiungi al carrello" per circa un secondo prima di correggersi.
  // Non e' mai la fonte di verita': la lettura del carrello che parte subito
  // dopo la sovrascrive comunque. Vive solo in questa scheda del browser, non
  // finisce nell'HTML e non e' condivisa fra visitatori.
  var STORAGE_KEY = 'cartStateKeys';

  function saveCache() {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(keysByVariant));
    } catch (error) {
      // Navigazione privata o storage pieno: si perde l'anticipo, non la
      // correttezza.
    }
  }

  function loadCache() {
    try {
      var raw = window.sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return false;

      var parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== 'object') return false;

      keysByVariant = parsed;
      return true;
    } catch (error) {
      return false;
    }
  }

  function cartUrl() {
    return (window.routes && window.routes.cart_url) || '/cart';
  }

  function goToCart() {
    window.location.href = cartUrl();
  }

  function forms() {
    return document.querySelectorAll('product-form');
  }

  function variantIdOf(form) {
    var input = form.querySelector('input[name="id"]');
    return input && input.value ? String(input.value) : null;
  }

  function buttonOf(form) {
    return form.querySelector('button[name="add"]');
  }

  // Sia sulla pagina prodotto sia sulle card, il primo <span> del pulsante e'
  // l'etichetta. Gli altri (.sold-out-message, .icon-wrap) vengono dopo.
  function labelOf(button) {
    return button.querySelector('span');
  }

  function readCart(cart) {
    keysByVariant = {};
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (items[i] && items[i].variant_id != null && items[i].key) {
        keysByVariant[String(items[i].variant_id)] = items[i].key;
      }
    }

    // Anche gli aggiornamenti che arrivano dalla pagina carrello passano di
    // qui: togliendo un capo da /cart, la memoria e' gia' corretta prima che
    // il visitatore torni indietro sulla scheda del prodotto.
    saveCache();
  }

  function fetchCart() {
    // no-store + parametro variabile: tornando indietro da /cart, alcuni
    // browser in-app servivano la risposta precedente di /cart.js dalla
    // propria cache, e il pulsante restava su "Nel carrello" per un capo
    // appena rimosso (riscontrato nei test manuali del 2026-09-17).
    var url = cartUrl() + '.js?cart-state=' + Date.now();

    return fetch(url, { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (response) {
        if (!response.ok) throw new Error('cart.js ' + response.status);
        return response.json();
      })
      .then(function (cart) {
        cartLoaded = true;
        readCart(cart);
        applyAll();
        return cart;
      });
  }

  function setInCart(button, key) {
    button.dataset.inCartKey = key;

    // Se il 422 e' gia' passato di qui, product-form.js ha nascosto
    // l'etichetta e mostrato "Esaurito": va rimesso a posto prima di tutto.
    var soldOut = button.querySelector('.sold-out-message');
    var label = labelOf(button);
    if (soldOut && label && !soldOut.classList.contains('hidden')) {
      soldOut.classList.add('hidden');
      label.classList.remove('hidden');
      button.removeAttribute('aria-disabled');
    }

    if (button.getAttribute(IN_CART_ATTR) === 'true') return;
    if (!label || !strings.inCart) return;

    button.dataset.cartStateLabel = label.textContent;
    button.dataset.cartStateHadPopup = button.hasAttribute('aria-haspopup') ? '1' : '0';
    label.textContent = strings.inCart;
    button.setAttribute('aria-haspopup', 'dialog');
    button.setAttribute(IN_CART_ATTR, 'true');
    // NOTA: il pulsante resta type="submit". Commutarlo a type="button"
    // sembrerebbe piu' pulito, ma il costruttore di product-form.js fa
    // this.querySelector('[type="submit"]') e poi ne legge lo <span>: se il
    // nostro stato arrivasse prima che quel file sia stato scaricato (rete
    // lenta, in-app browser), il costruttore troverebbe null e lancerebbe,
    // lasciando il form senza JS. La seconda aggiunta viene impedita dai due
    // gestori in fondo a questo file (click e submit, in fase di cattura),
    // che non dipendono dall'ordine di caricamento degli script.
  }

  function clearInCart(button) {
    if (button.getAttribute(IN_CART_ATTR) !== 'true') return;

    var label = labelOf(button);
    if (label && typeof button.dataset.cartStateLabel === 'string') {
      label.textContent = button.dataset.cartStateLabel;
    }
    if (button.dataset.cartStateHadPopup !== '1') button.removeAttribute('aria-haspopup');
    button.removeAttribute(IN_CART_ATTR);
    delete button.dataset.inCartKey;
    delete button.dataset.cartStateLabel;
    delete button.dataset.cartStateHadPopup;
  }

  function applyAll() {
    // Scriviamo nel DOM osservato: l'observer si stacca e si riattacca,
    // altrimenti si richiamerebbe da solo a ogni etichetta scritta.
    if (domObserver) domObserver.disconnect();

    var list = forms();
    for (var i = 0; i < list.length; i++) {
      var button = buttonOf(list[i]);
      if (!button) continue;

      var variantId = variantIdOf(list[i]);
      var key = variantId ? keysByVariant[variantId] : null;

      if (key) {
        // Un pulsante disabilitato (esaurito, non disponibile, "In arrivo")
        // non va toccato: non e' questo fix a decidere quei casi.
        if (!button.disabled) setInCart(button, key);
      } else {
        clearInCart(button);
      }
    }

    observeDom();
  }

  function setBusy(button, busy) {
    var form = button.closest('product-form');
    var spinner = form ? form.querySelector('.loading__spinner') : null;

    button.dataset.cartStateBusy = busy ? '1' : '';
    button.classList.toggle('loading', busy);
    if (spinner) spinner.classList.toggle('hidden', !busy);
  }

  // Un update a vuoto: non cambia nulla nel carrello, ma restituisce in una
  // sola richiesta sia il carrello aggiornato sia l'HTML delle sezioni della
  // notifica, esattamente come fa il tema dopo un'aggiunta.
  function fetchCartAndSections() {
    var url = (window.routes && window.routes.cart_update_url) || '/cart/update.js';

    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: {}, sections: SECTIONS, sections_url: window.location.pathname }),
    }).then(function (response) {
      if (!response.ok) throw new Error('cart/update.js ' + response.status);
      return response.json();
    });
  }

  // renderContents() di cart-notification.js legge due nodi precisi dentro
  // l'HTML della sezione e non regge il caso in cui manchino: meglio
  // verificarli qui e, se non ci sono, degradare sulla pagina carrello.
  function sectionsUsable(sections, key) {
    if (!sections) return false;

    for (var i = 0; i < SECTIONS.length; i++) {
      if (typeof sections[SECTIONS[i]] !== 'string') return false;
    }

    var parsed = new DOMParser().parseFromString(sections['cart-notification-product'], 'text/html');
    if (!parsed.querySelector('[id="cart-notification-product-' + key + '"]')) return false;
    if (!parsed.querySelector('.cart-shipping-bar')) return false;

    return true;
  }

  function openNotification(button) {
    var notification = document.querySelector('cart-notification');
    if (!notification || typeof notification.renderContents !== 'function') return goToCart();
    if (button.dataset.cartStateBusy === '1') return;

    setBusy(button, true);

    fetchCartAndSections()
      .then(function (cart) {
        readCart(cart);
        applyAll();

        var key = button.dataset.inCartKey;
        // Rimosso nel frattempo (altra scheda, altro dispositivo): applyAll ha
        // gia' rimesso il pulsante su "Aggiungi al carrello", non c'e' niente
        // da aprire.
        if (button.getAttribute(IN_CART_ATTR) !== 'true' || !key) return;
        if (!sectionsUsable(cart.sections, key)) return goToCart();

        notification.setActiveElement(button);
        notification.renderContents({ key: key, sections: cart.sections });
      })
      .catch(function (error) {
        console.error(error);
        goToCart();
      })
      .then(function () {
        setBusy(button, false);
      });
  }

  function showAlreadyInCart(variantId) {
    var list = forms();
    for (var i = 0; i < list.length; i++) {
      if (variantIdOf(list[i]) !== variantId) continue;

      var wrapper = list[i].querySelector('.product-form__error-message-wrapper');
      var message = list[i].querySelector('.product-form__error-message');
      if (!wrapper || !message) continue;

      message.textContent = strings.alreadyInCart;
      wrapper.removeAttribute('hidden');
    }
  }

  function containsForm(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.tagName === 'PRODUCT-FORM') return true;

    return !!(node.querySelector && node.querySelector('product-form'));
  }

  function onMutations(records) {
    for (var i = 0; i < records.length; i++) {
      var added = records[i].addedNodes;

      for (var j = 0; j < added.length; j++) {
        if (!containsForm(added[j])) continue;

        if (cartLoaded) {
          // Pulsanti nuovi e stato gia' in memoria: nessuna richiesta.
          applyAll();
        } else {
          // Pagina che all'apertura non aveva pulsanti di aggiunta: la scheda
          // marchio dell'Atlante (pagina Manifatture) chiede le sue card via
          // Section Rendering API solo quando apri un marchio. Il carrello non
          // era ancora stato letto: si legge ora, applicando intanto quanto
          // sappiamo dalla sessione.
          if (loadCache()) applyAll();
          fetchCart().catch(function (error) {
            console.error(error);
          });
        }

        return;
      }
    }
  }

  function observeDom() {
    if (typeof MutationObserver === 'undefined' || !document.body) return;

    // Tutta la pagina, non la sola griglia di collezione: i pulsanti di
    // aggiunta compaiono anche dove non c'era nulla al caricamento (scheda
    // marchio dell'Atlante, modale quick-add, re-render del carrello). Il
    // filtro qui sotto tiene il costo a zero finche' non compare davvero un
    // pulsante nuovo.
    if (!domObserver) domObserver = new MutationObserver(onMutations);

    domObserver.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var button = target.closest('button[' + IN_CART_ATTR + '="true"]');
      if (!button) return;

      // In fase di cattura: il tap non arriva ne' al form ne' al gestore che
      // chiude la notifica appena aperta.
      event.preventDefault();
      event.stopPropagation();
      openNotification(button);
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.querySelector) return;

      var button = form.querySelector('button[' + IN_CART_ATTR + '="true"]');
      if (!button) return;

      // Rete di sicurezza per le vie che non passano da un click sul pulsante
      // (tasto Invio, submit programmatico): senza questa, il form partirebbe
      // e Shopify risponderebbe 422.
      event.preventDefault();
      event.stopPropagation();
    },
    true
  );

  if (typeof subscribe === 'function') {
    subscribe(events.cartUpdate, function (data) {
      var cartData = data && data.cartData;
      if (!cartData) return;

      if (Array.isArray(cartData.items)) {
        // Aggiornamento che porta l'intero carrello (es. assets/cart.js).
        readCart(cartData);
        applyAll();
        return;
      }

      // Risposta di /cart/add.js: e' la riga appena aggiunta. Lo stato cambia
      // nell'istante dell'aggiunta, senza nessuna richiesta in piu'.
      if (cartData.variant_id != null && cartData.key) {
        keysByVariant[String(cartData.variant_id)] = cartData.key;
        saveCache();
        applyAll();
      }
    });

    subscribe(events.cartError, function (data) {
      // Corsa persa: qualcuno ha premuto prima che il carrello fosse letto.
      // Invece del messaggio di Shopify ("puoi aggiungerne solo 1..."),
      // diciamo la verita' — se il capo risulta davvero gia' nel carrello.
      // La verifica e' sui dati, mai sul testo dell'errore, che e' tradotto.
      var variantId = data && data.productVariantId ? String(data.productVariantId) : null;

      fetchCart()
        .then(function () {
          if (!variantId || !keysByVariant[variantId] || !strings.alreadyInCart) return;
          showAlreadyInCart(variantId);
        })
        .catch(function (error) {
          console.error(error);
        });
    });

    subscribe(events.variantChange, function () {
      applyAll();
    });
  }

  window.addEventListener('pageshow', function (event) {
    // Ritorno indietro da /cart: la pagina arriva dalla cache di navigazione,
    // con lo stato di prima della rimozione.
    if (!event.persisted) return;

    fetchCart().catch(function (error) {
      console.error(error);
    });
  });

  function init() {
    // Si osserva sempre: certe pagine i pulsanti di aggiunta li caricano dopo
    // (vedi onMutations).
    observeDom();

    // Nessun pulsante di aggiunta in pagina (home, blog): nessuna richiesta,
    // nessun costo.
    if (!forms().length) return;

    // Prima lo stato noto dalla sessione, cosi' e' gia' giusto al primo
    // disegno della pagina; poi la verifica sul carrello reale.
    if (loadCache()) applyAll();

    fetchCart().catch(function (error) {
      console.error(error);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
